import { useTranslation } from "react-i18next";
import {
  useCreateExitTicketGenerator,
  useGetExitTicketGenerator,
  getExitTicketGenerator,
} from "@packages/api/madlenAPI";
import { ExitTicketGeneratorResponseDto } from "@packages/api/madlenAPI.schemas";
import { ExitTicketCreateModal } from "../../../components/create-modal/modals";
import {
  ExitTicket,
  ExitTicketCard,
} from "../../../components/exit_tickets/ExitTicketCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import i18n from "@packages/i18n/config";

const CreateExitTicketView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: {
    initialInput: any;
    onSubmit: (input: any) => Promise<void>;
    isLoading: boolean;
    error: Error | null;
  }) => (
    <ExitTicketCreateModal
      title={t("quickActions.exitTicketsCreate")}
      backPath="/content/exit-tickets"
      themeColor="mint"
      loadingTitle={t("exitTickets.submit.loading.title")}
      errorTitle={t("exitTickets.submit.error.title")}
      errorDescription={t("exitTickets.submit.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput}
      onSubmit={onSubmit}
      isLoading={isLoading}
      error={error}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: ExitTicketGeneratorResponseDto;
    isImageLoading: boolean;
    onCreateAgain: () => void;
  }) => (
    <ExitTicketCard
      toolId={toolData.id}
      authorName={toolData.authorName || ""}
      authorId={toolData.authorId}
      courseName={toolData.courseName || ""}
      gradeLevel={toolData.gradeLevel || 0}
      imageUrl={toolData.imageUrl || ""}
      exitTickets={(toolData.exitTickets as ExitTicket[]) || []}
      isImageLoading={isImageLoading}
      topic={toolData.title || toolData.prompt || ""}
      createdAt={toolData.createdAt ?? ""}
      status={toolData.status}
      onCreateAgain={onCreateAgain}
      contentLanguage={toolData.contentLanguage || i18n.language}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="exit-tickets"
      useCreateTool={useCreateExitTicketGenerator}
      useGetTool={useGetExitTicketGenerator}
      getTool={getExitTicketGenerator}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: ExitTicketGeneratorResponseDto) =>
        data?.exitTickets &&
        (data.status === "READY" || data.status === "REGENERATING")
      }
    />
  );
};

export default CreateExitTicketView;
